import type { UseQueryResult } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { globalQueryClient } from 'queries/queryClient'
import { useHistory } from 'react-router-dom'
import type {
  Customer,
  CustomerListResponse,
  CustomerParams,
} from 'types/customer'

import { QUERIES } from '@/enums/queries'

import { getCustomer, getCustomers } from './services/loadCustomers'

export const useLoadCustomers = (
  params: CustomerParams,
  options: any
  // $FlowFixMe
): UseQueryResult<CustomerListResponse, Error> => {
  return useQuery({
    queryKey: [QUERIES.CUSTOMERS.LIST, params],
    queryFn: ({ signal }: { signal: AbortSignal }) => {
      return getCustomers(params, { signal })
    },
    ...options,
  })
}

export const useLoadCustomer = (
  id: string,
  options: any
  // $FlowFixMe
): UseQueryResult<Customer, Error> => {
  const history = useHistory()
  return useQuery({
    queryKey: [QUERIES.CUSTOMERS.GET, id],
    queryFn: () => {
      return getCustomer(id)
    },
    onError: () => history.push('/clients'),
    ...options,
  })
}

export const invalidateLoadCustomers = async (id?: string) => {
  await globalQueryClient.invalidateQueries({
    queryKey: [QUERIES.CUSTOMERS.LIST],
    exact: false,
  })

  if (id) {
    await globalQueryClient.invalidateQueries({
      queryKey: [QUERIES.CUSTOMERS.GET, id],
      exact: false,
    })
  }
}

export const invalidLoadCustomerById = async (id: string) => {
  await globalQueryClient.invalidateQueries({
    queryKey: [QUERIES.CUSTOMERS.GET, id],
    exact: false,
  })
}
